import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {ActionBox} from 'shells/action-box/action-box';
import {ErrorIcon, SuccessIcon} from 'shells/action-box/action-icons';
import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
import {HalfAndHalfIcon} from 'shells/icon/svg/half-and-half-icon';
import {Link} from 'shells/link/link';

import type {EditionFragment as Edition} from 'nutshell-graphql-types';

import {isMissingComparisonSubject, isComparingSubject} from '../a-b-testing/helpers';

type Props = {
    edition: Edition;
    onClickActionItem?: () => any;
};

export function SubjectActionBox(props: Props) {
    return (
        <ActionBox
            title='Subject line'
            subtitle={getSubjectText(props.edition)}
            icon={
                props.edition.emailTemplate &&
                props.edition.emailTemplate.subject &&
                !isMissingComparisonSubject(props.edition) ? (
                    <SuccessIcon />
                ) : (
                    <ErrorIcon />
                )
            }
            actionElement={getSubjectActionElement(props.edition, props.onClickActionItem)}
        />
    );
}

function getSubjectText(edition: Edition) {
    if (isComparingSubject(edition)) {
        if (
            edition.emailTemplate &&
            edition.emailTemplate.subject &&
            !isMissingComparisonSubject(edition)
        ) {
            return (
                <div className='flex align-center' style={{color: colors.grey}}>
                    <HalfAndHalfIcon wrapWithDiv={false} size={13} />
                    <span style={{marginLeft: 4}}>A/B testing</span>
                </div>
            );
        } else {
            return 'Each version needs a subject line';
        }
    } else if (edition.emailTemplate && edition.emailTemplate.subject) {
        return edition.emailTemplate.subject;
    }

    return 'All messages need a subject line';
}

function getSubjectActionElement(edition: Edition, onClickAction?: () => any) {
    if (
        (edition.emailTemplate && !edition.emailTemplate.subject) ||
        isMissingComparisonSubject(edition)
    ) {
        // If there is an onClickAction then return a button here instead
        if (onClickAction) {
            return (
                <Button variant='text-primary' size='big' onClick={onClickAction}>
                    Edit subject line{edition.isABTesting ? '(s)' : ''}
                </Button>
            );
        }

        return (
            <div className='flex' style={{minWidth: 'fit-content'}}>
                {/* @ts-expect-error */}
                <Link variant='primary' to={`${edition.htmlUrlPath}/details`} as={RoutedLink}>
                    Edit subject line{edition.isABTesting ? '(s)' : ''}
                </Link>
            </div>
        );
    }
}
